import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Alert,
  Button,
  FormGroup,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";

import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";
import { getOnboarder, postOnboarder } from "../../../api/common";
import { showLoader, removeLoader } from "../../../store/Loader/actions";
import LiabilitieLine from "./liabilitieLine.js";
import { handleErrorsAllMessage } from "../../../utils";
import TotalLines from "../../TotalLines";
import {
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
} from "../../../store/CompanyState/actions";
import debounce from "lodash.debounce";
import ActionFooter from "../ActionFooter";
import ActionHeader from "../ActionHeader";

const Liabilities = ({
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
  company,
  activeCompanyIsEditable,
  showLoader,
  removeLoader,
}) => {
  let history = useHistory();
  const [canSave, setCanSave] = useState(false);
  const [errors, setErrors] = useState([]);
  const [lines, setLines] = useState([]);
  const [deleteLines, setDeleteLines] = useState([]);
  const [deleted, setDeleted] = useState([]);
  const [banks, setBanks] = useState([]);
  const [totalShortTerm, setTotalShortTerm] = useState(0);
  const [totalLongTerm, setTotalLongTerm] = useState(0);
  const form = useRef([]);

  const onValidSubmit = (e, vals) => {};
  const deleteLine = (id) => {
    setDeleted((deleted) => [...deleted, id]);
  };

  let save = debounce(() => {
    saveLiabilities(() => {
      setNextStep(null);
      saveActiveCompany();
    });
  }, 200);
  const saveExit = debounce(() => {
    saveLiabilities(() => {
      setNextStep("exit");
      history.goBack();
    });
  }, 200);
  const next = debounce(() => {
    saveLiabilities(() => {
      setNextStep("next");
      nextState();
    });
  }, 200);
  const back = debounce(() => {
    saveLiabilities(() => {
      setNextStep("back");
      previousState();
    });
  }, 200);
  const getBanks = () => {
    getOnboarder(`/OnboardingBase/bank/`).then((data) => {
      if (activeCompanyIsEditable)
        setBanks(data.filter((line) => line?.erp_id && line?.is_active));
      else {
        setBanks(data);
      }
    });
  };
  useEffect(() => {
    showLoader();
    getOnboarder(`/UserManagement/${company?.id}/liabilities/`)
      .then((data) => {
        data.forEach((line) => {
          line.updated = false;
          line.selected = false;
        });
        setLines(data);
        removeLoader();
      })
      .catch(() => {
        removeLoader();
      });

    getBanks();
    if (form.current) {
      form.current.setTouched(Object.keys(form.current._inputs));
      setCanSave(!form.current.hasError());
    }
  }, []);
  let saveLiabilities = (cb) => {
    const body = {
      liabilities: lines.filter((line) => line.updated),
      delete: deleteLines || [],
    };
    if (body.liabilities.length || body.delete.length) {
      setCanSave(false);
      showLoader();
      postOnboarder(`/UserManagement/${company?.id}/liabilities/submit`, body)
        .then((data) => {
          setErrors([]);
          data.forEach((line) => {
            line.updated = false;
            line.selected = false;
          });
          cb();
          setLines(data);
          setCanSave(true);
          removeLoader();
        })
        .catch((error) => {
          setErrors(error);
          removeLoader();
          setCanSave(true);
          throw error;
        });
    } else {
      setErrors({});
      cb();
    }
  };

  useEffect(() => {
    if (form.current) {
      form.current.setTouched(Object.keys(form.current._inputs));
      const values = form.current.getValues();
      form.current.validateAll(values).then((errors) => {
        if (form.current) {
          setCanSave(!form.current.hasError());
        }
      });
    }
    let sumOfShortTerm = lines
      .filter((line) => line.term == "short_term")
      .reduce((sum, line) => sum + parseFloat(line.amount), 0);
    setTotalShortTerm(sumOfShortTerm);
    let sumOfLongTerm = lines
      .filter((line) => line.term == "long_term")
      .reduce((sum, line) => sum + parseFloat(line.amount), 0);
    setTotalLongTerm(sumOfLongTerm);
  }, [lines]);

  useEffect(() => {
    const div = document.querySelector(".alert-danger");
    div?.scrollIntoView({ behavior: "auto", block: "center" });
  }, [errors]);
  const handleAddNew = () => {
    setLines((lines) => [...lines, { updated: true }]);
  };
  const deleteRows = debounce(() => {
    setLines((lines) => lines.filter((line) => !line.selected));
    setDeleteLines(
      lines.filter((line) => line.selected).map((line) => line.id)
    );
  }, 200);
  const toggleSelectAll = (e) => {
    const checked = e.target.checked;
    let items = [...lines];
    items.forEach((item) => {
      item.selected = checked;
    });
    setLines(items);
  };
  return (
    <div className="container-fluid">
      <ActionHeader
        canSave={canSave}
        save={save}
        deleteRows={deleteRows}
        lines={lines}
        saveExit={saveExit}
      />
      <Card style={{ marginBottom: "0rem" }}>
        <CardBody style={{ padding: "0.75rem", paddingBottom: "0rem" }}>
          <Row>
            <Col>
              {handleErrorsAllMessage(errors) && (
                <Alert color="danger">{handleErrorsAllMessage(errors)}</Alert>
              )}
            </Col>
          </Row>
          <AvForm
            className="needs-validation"
            ref={form}
            onValidSubmit={onValidSubmit}
          >
            <div className="table-container-input-with-total">
              <Table className="table-responsive-input">
                <Thead>
                  <Tr>
                    <Th style={{ minWidth: "10px" }}>
                      <FormGroup>
                        <AvField
                          type="checkbox"
                          name="selected"
                          onChange={toggleSelectAll}
                          disabled={!activeCompanyIsEditable}
                        />
                      </FormGroup>
                    </Th>
                    <Th>Type</Th>
                    <Th>Lender (Bank)</Th>
                    <Th>Amount</Th>
                    <Th>Loan Term</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {lines.map((line, index) => {
                    return (
                      <LiabilitieLine
                        key={index}
                        index={index}
                        line={line}
                        setLines={setLines}
                        deleteLine={deleteLine}
                        lines={lines}
                        banks={banks}
                      />
                    );
                  })}
                </Tbody>
              </Table>
            </div>
            {activeCompanyIsEditable && (
              <Button color="link" onClick={handleAddNew}>
                Add New Line
              </Button>
            )}
          </AvForm>

          <Row>
            <Col md="6">
              <TotalLines
                title="Total of Long Term Liability"
                total={totalLongTerm}
              />
            </Col>
            <Col md="6">
              <TotalLines
                title="Total of Short Term Liability"
                total={totalShortTerm}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ActionFooter
        next={next}
        canSave={canSave}
        back={back}
        complete={saveLiabilities}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    company: state.CompanyState.activeCompany,
    activeCompanyIsEditable: state.CompanyState.activeCompanyIsEditable,
  };
};
export default connect(mapStateToProps, {
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
  showLoader,
  removeLoader,
})(Liabilities);
